module.exports = __webpack_public_path__ + "static/media/print2.454e4d1b.jpg";